import {
  type AskPunttAttachment,
  type AskPunttProjectData,
} from "@mg/schemas/src/christo/askPuntt";

import { ChatDetailsPanel } from "./ChatDetailsPanel";
import { ChatReviewsPanel } from "./ChatReviewsPanel";

import { PROJECT_RAIL_WIDTH_PX } from "../utils/projectWorkspaceLayout";

/**
 * Fixed-width right rail for multi-ticket Ask Puntt browse mode. Mirrors the
 * project workspace layout: gray background, Reviews dropdown on top, Chat
 * Details dropdown below.
 */
export function MultiTicketBrowseRail({
  ticketIds,
  titleMap,
  onOpenReview,
  title,
  workflowType,
  description,
  findingsSummary,
  ticketFindings,
  uploadedFiles,
  reviewsStatus,
  isKillerFlowStreaming,
  hasActiveStage,
  reviewsOpen,
  onReviewsOpenChange,
  detailsOpen,
  onDetailsOpenChange,
  railTestId = "chat-reviews-rail",
}: {
  ticketIds: readonly string[];
  titleMap: Map<string, string>;
  onOpenReview: (ticketId: string) => void;
  title: string;
  workflowType?: string;
  description?: string;
  findingsSummary?: string;
  ticketFindings?: AskPunttProjectData["ticketFindings"];
  uploadedFiles?: readonly AskPunttAttachment[];
  reviewsStatus?: string;
  isKillerFlowStreaming?: boolean;
  hasActiveStage?: boolean;
  reviewsOpen: boolean;
  onReviewsOpenChange: (open: boolean) => void;
  detailsOpen: boolean;
  onDetailsOpenChange: (open: boolean) => void;
  railTestId?: string;
}) {
  return (
    <aside
      className="box-border flex h-full min-h-0 shrink-0 flex-col gap-3 overflow-hidden border-l border-puntt-neutral-gray-5 bg-puntt-neutral-gray-2 p-3"
      style={{
        width: PROJECT_RAIL_WIDTH_PX,
        minWidth: PROJECT_RAIL_WIDTH_PX,
        maxWidth: PROJECT_RAIL_WIDTH_PX,
        flexBasis: PROJECT_RAIL_WIDTH_PX,
      }}
      data-testid={railTestId}
      aria-label="Chat workspace sidebar"
    >
      <div
        className={`flex flex-col overflow-hidden ${reviewsOpen ? "max-h-[45%] min-h-32 shrink-0" : "shrink-0"}`}
        data-testid="chat-reviews-rail-slot"
        data-section-expanded={reviewsOpen ? "true" : "false"}
      >
        <ChatReviewsPanel
          ticketIds={ticketIds}
          titleMap={titleMap}
          onOpenReview={onOpenReview}
          status={reviewsStatus}
          open={reviewsOpen}
          onOpenChange={onReviewsOpenChange}
        />
      </div>
      <div
        className={`flex flex-col overflow-hidden ${detailsOpen ? "min-h-0 flex-1" : "shrink-0"}`}
        data-testid="chat-details-rail-slot"
        data-section-expanded={detailsOpen ? "true" : "false"}
      >
        <ChatDetailsPanel
          title={title}
          workflowType={workflowType}
          description={description}
          findingsSummary={findingsSummary}
          ticketFindings={ticketFindings}
          uploadedFiles={uploadedFiles}
          isKillerFlowStreaming={isKillerFlowStreaming}
          hasActiveStage={hasActiveStage}
          panelOpen={detailsOpen}
          onPanelOpenChange={onDetailsOpenChange}
        />
      </div>
    </aside>
  );
}
